import type { WithActiveBranchId } from '@app/api/shared';

export enum RobotAttachmentsEndpoints {
  UploadRobotAttachment = 'UploadRobotAttachment',
  GetRobotAttachmentsList = 'GetRobotAttachmentsList',
}

export interface ModelRobotAttachment {
  Id: number;
  Name: string | null;
}

export type UploadRobotAttachmentRequest = WithActiveBranchId<{
  stageId: number;
  data: FormData;
}>;

export type GetRobotAttachmentsListRequest = WithActiveBranchId<{
  robotId: number;
}>;

export type UploadRobotAttachmentResponse = number;
export type GetRobotAttachmentsListResponse = ModelRobotAttachment[];
